import React, { useState } from "react"
import { Input, Container, Form, FormGroup, Alert } from "reactstrap"
import validateInput from "../../view/shared/validations/pinReset"
import { toast } from "react-toastify"
import { createBrowserHistory } from "history"
import { Trans, useLingui } from "@lingui/react"
import PropTypes from "prop-types"
import { AuthAPI } from "../../store/api"

const history = createBrowserHistory({ forceRefresh: true })

const SuccessMessage = () => {
  return (
    <div style={loadingStyle}>
      <Trans id="pin.reset.success" />
    </div>
  )
}

const ErrorMessage = () => {
  return (
    <div style={loadingStyle}>
      <Trans id="pin.reset.error" />
    </div>
  )
}

const PinReset = (props) => {
  const [pin, setPin] = useState("")
  const [confirmPin, setConfirmPin] = useState("")
  const [errors, setErrors] = useState({})

  const notify = (msg) => toast.info(msg)

  const onChange = (e) => {
    if (e.target.name === "pin") {
      setPin(e.target.value)
    } else if (e.target.name === "confirm_pin") {
      setConfirmPin(e.target.value)
    }
  }

  const isValid = () => {
    const { errors, isValid } = validateInput({ pin, confirm_pin: confirmPin })
    if (!isValid) {
      setErrors(errors)
    }
    return isValid
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (isValid()) {
      resetPin()
        .then(() => {
          notify(<SuccessMessage />)
          history.push({
            pathname: `/`,
          })
        })
        .catch((error) => {
          const { response } = error
          if (!response.data) {
            return
          }
          notify(<ErrorMessage />)
        })
    } else {
      setPin("")
      setConfirmPin("")
    }
  }

  const resetPin = async () => {
    const { phone, pincode } = props.location
    await AuthAPI.post(`/reset-pin?lan=${window.i18n.locale}`, {
      otp: pincode,
      newPin: pin,
      phoneNumber: phone,
    })
  }

  const { i18n } = useLingui()
  const login_pin = i18n._("Login PIN")
  const login_pin_confirm = i18n._("Confirm PIN")
  const submit = i18n._("Submit")

  const formStyle = {
    flex: "10",
    padding: "5px",
    fontFamily: "Fira Sans",
    fontSize: "20px",
    height: "50px",
  }

  return (
    <div>
      <Container>
        <Alert color="secondary" style={loadingStyle}>
          <Trans id="submit.sms.code" />
        </Alert>
        <Form onSubmit={onSubmit}>
          <FormGroup>
            <span style={{ color: "red" }}>{errors.pin}</span>
            <Input
              type="password"
              name="pin"
              style={formStyle}
              placeholder={login_pin}
              onChange={onChange}
              error={errors.pin}
              value={pin}
            />
          </FormGroup>
          <FormGroup>
            <span style={{ color: "red" }}>{errors.confirm_pin}</span>
            <Input
              type="password"
              name="confirm_pin"
              style={formStyle}
              placeholder={login_pin_confirm}
              onChange={onChange}
              error={errors.confirm_pin}
              value={confirmPin}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="submit"
              value={submit}
              name="submit"
              className="btn btn-primary"
              size="lg"
            />
          </FormGroup>
        </Form>
      </Container>
    </div>
  )
}

PinReset.propTypes = {
  location: PropTypes.shape({
    phone: PropTypes.string,
    pincode: PropTypes.string,
  }),
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "18px",
}

export default PinReset
